import {Component, OnDestroy, OnInit} from '@angular/core';
import {SummaryPage} from '../models/summary-page';
import {environment} from '../../environments/environment';
import {forkJoin, Observable} from 'rxjs';
import {PageStatus} from '../models/page-status';
import {StatusPageService} from '../services/status-page.service';
import {HelperService} from '../services/helper.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit, OnDestroy {

  public StatusResponses = new Array<SummaryPage>();
  private interval: number;

  constructor(
    private router: Router,
    private statusPageService: StatusPageService,
    private helperService: HelperService
  ) { }

  selectedIndex: number;

  ngOnInit(): void {
    this.getStatuses();
    this.interval = setInterval(() => {
      this.getStatuses();
    }, 60000);
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  getStatuses(): void {
    const statusPages: Array<SummaryPage> = environment.statusPages;
    const allObs = new Array<Observable<PageStatus>>();

    statusPages.forEach(page => {
      allObs.push(this.statusPageService.GetPageStatus(page.statusPageUrl + page.statusUrl));
    });

    forkJoin(allObs)
      .subscribe(
        (data) => {
          data.forEach((obj, index) => {
            // set to default status
            statusPages[index].status = 'Status Unknown';
            // update status if available
            if (obj && obj.status?.description && obj.status?.description?.length > 0)
            {
              statusPages[index].status = obj.status.description;
            }
            // after updating status, push to StatusResponses array
            this.StatusResponses.push(statusPages[index]);
          });
          this.StatusResponses = this.helperService.groupByProduct(statusPages);
        }
      );
  }

  navigateToDetailPage(tabIndex: number, region: string): void {
    this.helperService.passDataToUrlParam(tabIndex, region );
  }

}
